import { Grid } from '@mui/material';

import { FormCard, RenderFormField } from '@/components';

export enum DispositionFormValues {
  WRONG_NUMBER = 'Wrong Number',
  CREATED_IN_ERROR = 'Created in Error',
  NEW_CFS = 'New CFS',
  EXISTING_CFS = 'Existing CFS',
  PHONY_CALL = 'Phony Call',
  SHIFT_CHANGE = 'Shift Change',
  TEST = 'Test',
  OTHER = 'Other',
}

export const DispositionForm = () => {
  return (
    <FormCard>
      <Grid sm={12} item>
        <RenderFormField
          name="disposition"
          type="select"
          items={[
            {
              label: DispositionFormValues.NEW_CFS,
              value: DispositionFormValues.NEW_CFS,
            },
            {
              label: DispositionFormValues.EXISTING_CFS,
              value: DispositionFormValues.EXISTING_CFS,
              disabled: true,
            },
            {
              label: DispositionFormValues.WRONG_NUMBER,
              value: DispositionFormValues.WRONG_NUMBER,
            },
            {
              label: DispositionFormValues.CREATED_IN_ERROR,
              value: DispositionFormValues.CREATED_IN_ERROR,
            },
            {
              label: DispositionFormValues.PHONY_CALL,
              value: DispositionFormValues.PHONY_CALL,
            },
            {
              label: DispositionFormValues.SHIFT_CHANGE,
              value: DispositionFormValues.SHIFT_CHANGE,
            },
            {
              label: DispositionFormValues.TEST,
              value: DispositionFormValues.TEST,
            },
            {
              label: DispositionFormValues.OTHER,
              value: DispositionFormValues.OTHER,
            },
          ]}
          label="Call Disposition"
        />
      </Grid>
    </FormCard>
  );
};
